import { useMinSubscriptionValue } from 'hooks/use-min-subscription-value';
import { EffectiveCart } from 'interfaces/cart';

interface PropTypes {
  effectiveCart?: EffectiveCart;
}

/** Checks whether any subscription group is below the country-specific minimum. */
const useContainsLowRateSubscription = ({ effectiveCart }: PropTypes) => {
  const minimumSubscriptionValue = useMinSubscriptionValue();
  const containsLowRateSubscription = effectiveCart?.subscriptions?.some(
    (subscription) => subscription.totalAmount < minimumSubscriptionValue
  );

  return { containsLowRateSubscription };
};

export default useContainsLowRateSubscription;
